
const List = [
	'de_DE',
	'de_LU',
	'de_AT',
	'de_CH',
	'da_DK',
	'en_GB',
	'en_DE',
	'en_IE',
	'en_XI',
	'es_ES',
	'fr_FR',
	'fr_CH',
	'hu_HU',
	'it_IT',
	'it_CH',
	'nl_NL',
	'ro_RO',
	'sv_SE',
	'lt_LT',
	'hr_HR'
];

function getLanguagePriority(mainLang, fbLang) {
	if (!mainLang) throw new Error('must specify main language');
	let toCheck = [mainLang];
	let baseLang = mainLang.substring(0, 2);
	let country = mainLang.split('_').pop();
	this.List.forEach(lang => {
		if (lang.substring(0, 2) === baseLang) {
			toCheck.push(lang);
		}
	});
	this.List.forEach(lang => {
		if (lang.substring(3, 5) === country) {
			toCheck.push(lang);
		}
	});
	if (fbLang) toCheck.push(fbLang);
	return toCheck.filter(onlyUnique);
}

function onlyUnique(value, index, self) {
	return self.indexOf(value) === index;
}

module.exports = {
	List,
	getLanguagePriority
};
